<template>
  <v-container>
    <v-card>
      <v-card-title>Contracts</v-card-title>
      <v-card-text>
        <v-row
              class="pt-2"
            >
              <v-col
                v-for="(contract, i) in liveContracts"
                :key="`contract-${i}`"
                cols="12"
                md="4"
                lg="3"
              >
                <v-card
                  elevation="2"
                >
                  <v-card-title>
                    <v-sheet
                      color="accent"
                      width="100%"
                      class="overflow-hidden mt-n6 transition-swing"
                      elevation="3"
                      max-width="100%"
                      rounded
                    >
                      <v-theme-provider
                        dark
                      >
                        <div>
                          <v-icon
                            class="pa-2"
                          >
                            mdi-web
                          </v-icon>
                          <span
                            class="text-h6 white--text"
                          >
                            <router-link
                              :to="`/contracts/${contract.contract_id}`"
                              class="text-decoration-none white--text"
                            >
                              {{ contract.contract_name }}
                            </router-link>
                          </span>
                        </div>
                      </v-theme-provider>
                    </v-sheet>
                  </v-card-title>
                  <v-card-text>
                    <v-simple-table dense>
                      <tbody>
                        <tr>
                          <td>Contract</td>
                          <td>{{ contract.contract_number }}</td>
                        </tr>
                        <tr>
                          <td>Status</td>
                          <td>{{ contract.status }}</td>
                        </tr>
                      </tbody>
                    </v-simple-table>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
  export default {
    name: 'SoftwareContracts',
    props: {
      contracts: Array,
    },
    data () {
      return {
        
      }
    },
    computed: {
      liveContracts: function () {
        return this.contracts.filter(element => element.status !== 'DR' && element.status !== 'Decommissioned' && element.deleted === 'n')
      }
    }
  }
</script>